import { render, staticRenderFns } from "./app.message.vue?vue&type=template&id=748a74da&"
import script from "./app.message.vue?vue&type=script&lang=js&"
export * from "./app.message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports